import React, { useState } from 'react';
import { Search, Filter, Star, ChevronDown, X } from 'lucide-react';
interface MarketplaceProps {
  userRole: 'Program Manager' | 'Founder';
}
const Marketplace: React.FC<MarketplaceProps> = ({
  userRole
}) => {
  const [showModal, setShowModal] = useState(false);
  const [deploySuccess, setDeploySuccess] = useState(false);
  const handleOpenModal = () => {
    setShowModal(true);
  };
  const handleDeploy = () => {
    setDeploySuccess(true);
    setTimeout(() => {
      setShowModal(false);
      setTimeout(() => {
        setDeploySuccess(false);
      }, 3000);
    }, 500);
  };
  return <div className="w-full pt-6 px-6" data-id="element-739">
      <h1 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-740">Marketplace</h1>
      {/* Search and Filters */}
      <div className="flex justify-between mb-6" data-id="element-741">
        <div className="relative w-64" data-id="element-742">
          <input type="text" placeholder="Search agents..." className="w-full pl-10 pr-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-743" />
          <Search className="absolute left-3 top-2.5 text-gray-400" size={18} data-id="element-744" />
        </div>
        <div className="flex space-x-3" data-id="element-745">
          <div className="relative" data-id="element-746">
            <button className="px-4 py-2 bg-white border border-gray-300 rounded-md flex items-center text-sm text-gray-700" data-id="element-747">
              <Filter size={14} className="mr-2 text-gray-500" data-id="element-748" />
              Category: All
              <ChevronDown size={14} className="ml-2 text-gray-500" data-id="element-749" />
            </button>
          </div>
          <div className="relative" data-id="element-750">
            <button className="px-4 py-2 bg-white border border-gray-300 rounded-md flex items-center text-sm text-gray-700" data-id="element-751">
              Sort by: Popular
              <ChevronDown size={14} className="ml-2 text-gray-500" data-id="element-752" />
            </button>
          </div>
        </div>
      </div>
      {/* Agent Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-753">
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm" data-id="element-754">
          <div className="p-6" data-id="element-755">
            <div className="flex justify-between items-start mb-3" data-id="element-756">
              <div className="w-10 h-10 rounded-md bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-757">
                <Star size={20} data-id="element-758" />
              </div>
              <div className="px-2 py-1 bg-purple-100 text-purple-700 text-xs rounded-full" data-id="element-759">
                Program Approved
              </div>
            </div>
            <h3 className="text-lg font-medium text-gray-800 mb-1" data-id="element-760">
              Stakeholder Mapping Researcher
            </h3>
            <p className="text-sm text-gray-500 mb-3" data-id="element-761">Discovery</p>
            <div className="flex justify-between text-sm mb-4" data-id="element-762">
              <span className="text-gray-600" data-id="element-763">Usage: 58</span>
              <span className="text-gray-600" data-id="element-764">Est. 45 credits</span>
            </div>
            <button onClick={handleOpenModal} className="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors" data-id="element-765">
              Deploy to venture
            </button>
          </div>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm" data-id="element-766">
          <div className="p-6" data-id="element-767">
            <div className="flex justify-between items-start mb-3" data-id="element-768">
              <div className="w-10 h-10 rounded-md bg-green-100 flex items-center justify-center text-green-600" data-id="element-769">
                <Star size={20} data-id="element-770" />
              </div>
              <div className="px-2 py-1 bg-purple-100 text-purple-700 text-xs rounded-full" data-id="element-771">
                Program Approved
              </div>
            </div>
            <h3 className="text-lg font-medium text-gray-800 mb-1" data-id="element-772">
              Elevator Pitch Coach
            </h3>
            <p className="text-sm text-gray-500 mb-3" data-id="element-773">Messaging</p>
            <div className="flex justify-between text-sm mb-4" data-id="element-774">
              <span className="text-gray-600" data-id="element-775">Usage: 74</span>
              <span className="text-gray-600" data-id="element-776">Est. 30 credits</span>
            </div>
            <button onClick={handleOpenModal} className="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors" data-id="element-777">
              Deploy to venture
            </button>
          </div>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm" data-id="element-778">
          <div className="p-6" data-id="element-779">
            <div className="flex justify-between items-start mb-3" data-id="element-780">
              <div className="w-10 h-10 rounded-md bg-yellow-100 flex items-center justify-center text-yellow-600" data-id="element-781">
                <Star size={20} data-id="element-782" />
              </div>
              <div className="px-2 py-1 bg-purple-100 text-purple-700 text-xs rounded-full" data-id="element-783">
                Program Approved
              </div>
            </div>
            <h3 className="text-lg font-medium text-gray-800 mb-1" data-id="element-784">
              Presentation Agent
            </h3>
            <p className="text-sm text-gray-500 mb-3" data-id="element-785">Assets</p>
            <div className="flex justify-between text-sm mb-4" data-id="element-786">
              <span className="text-gray-600" data-id="element-787">Usage: 41</span>
              <span className="text-gray-600" data-id="element-788">Est. 80 credits</span>
            </div>
            <button onClick={handleOpenModal} className="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors" data-id="element-789">
              Deploy to venture
            </button>
          </div>
        </div>
      </div>
      {/* Deploy Success Message */}
      {deploySuccess && <div className="fixed bottom-4 right-4 bg-green-100 border border-green-200 text-green-800 px-4 py-3 rounded-lg shadow-md flex items-center" data-id="element-790">
          <span data-id="element-791">Stakeholder Mapping Researcher deployed to CardioSense</span>
          <button onClick={() => setDeploySuccess(false)} className="ml-3 p-1 hover:bg-green-200 rounded-full" data-id="element-792">
            <X size={16} data-id="element-793" />
          </button>
        </div>}
      {/* Detail Modal */}
      {showModal && <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50" data-id="element-794">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl" data-id="element-795">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-796">
              <h2 className="text-lg font-medium text-gray-800" data-id="element-797">
                Stakeholder Mapping Researcher
              </h2>
              <button onClick={() => setShowModal(false)} className="p-1 rounded-full hover:bg-gray-100" data-id="element-798">
                <X size={20} className="text-gray-500" data-id="element-799" />
              </button>
            </div>
            <div className="p-6" data-id="element-800">
              <div className="grid grid-cols-3 gap-6" data-id="element-801">
                <div className="col-span-2" data-id="element-802">
                  <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-803">
                    About
                  </h3>
                  <p className="text-sm text-gray-600 mb-4" data-id="element-804">
                    The Stakeholder Mapping Researcher helps identify and
                    prioritize key stakeholders in your problem space. It
                    analyzes transcripts and research to create comprehensive
                    stakeholder maps with influence/interest matrices.
                  </p>
                  <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-805">
                    Required inputs
                  </h3>
                  <ul className="text-sm text-gray-600 mb-4 list-disc pl-5" data-id="element-806">
                    <li data-id="element-807">Interview transcripts</li>
                    <li data-id="element-808">Problem statement</li>
                    <li data-id="element-809">Optional: Existing stakeholder list</li>
                  </ul>
                  <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-810">
                    Example output
                  </h3>
                  <div className="bg-gray-50 p-3 rounded-md text-sm text-gray-600 mb-4" data-id="element-811">
                    <p className="font-medium" data-id="element-812">
                      Stakeholder Map with 3 categories:
                    </p>
                    <ul className="list-disc pl-5 mt-1" data-id="element-813">
                      <li data-id="element-814">Primary: Cardiac Rehab Directors, Patients</li>
                      <li data-id="element-815">Secondary: Nurses, Insurance Providers</li>
                      <li data-id="element-816">Tertiary: Hospital Administrators</li>
                    </ul>
                  </div>
                </div>
                <div data-id="element-817">
                  <div className="bg-gray-50 p-4 rounded-md mb-4" data-id="element-818">
                    <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-819">
                      Details
                    </h3>
                    <div className="space-y-2" data-id="element-820">
                      <div className="flex justify-between text-sm" data-id="element-821">
                        <span className="text-gray-600" data-id="element-822">Category:</span>
                        <span className="text-gray-800" data-id="element-823">Discovery</span>
                      </div>
                      <div className="flex justify-between text-sm" data-id="element-824">
                        <span className="text-gray-600" data-id="element-825">Author:</span>
                        <span className="text-gray-800" data-id="element-826">Studio</span>
                      </div>
                      <div className="flex justify-between text-sm" data-id="element-827">
                        <span className="text-gray-600" data-id="element-828">Version:</span>
                        <span className="text-gray-800" data-id="element-829">1.2.0</span>
                      </div>
                      <div className="flex justify-between text-sm" data-id="element-830">
                        <span className="text-gray-600" data-id="element-831">Usage:</span>
                        <span className="text-gray-800" data-id="element-832">58 runs</span>
                      </div>
                      <div className="flex justify-between text-sm" data-id="element-833">
                        <span className="text-gray-600" data-id="element-834">Est. credits:</span>
                        <span className="text-gray-800" data-id="element-835">45 per run</span>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-836">
                    <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-837">
                      Actions
                    </h3>
                    <div className="space-y-2" data-id="element-838">
                      <button onClick={handleDeploy} className="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors" data-id="element-839">
                        Deploy to CardioSense
                      </button>
                      <button className="w-full py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors" data-id="element-840">
                        Submit new version
                      </button>
                      {userRole === 'Program Manager' && <button className="w-full py-2 bg-green-600 hover:bg-green-700 text-white rounded-md transition-colors" data-id="element-841">
                          Approve
                        </button>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </div>;
};
export default Marketplace;